import React, { useState, useEffect, useContext } from "react";
import "../../../ui-styles/profile/ProfileDetails.css";
import "../../../ui-styles/profile/HzntlProfile.css";
import { LangCtx } from "../../../lib/context";
import { getAge, dateFormat } from "../../../lib/functions";
import { getPatientDrugAllegiesById } from "../../../actions/appointment";
import { getUserDetails } from "../../../actions/users";
import Loader from "../../../lib/ui/loader/Loader";
import {API} from 'aws-amplify';

const PatientMedicalProfile = (props) => {
    const { l } = useContext(LangCtx);

    const [patient, setPatient] = useState({});
    const [loading, setLoading] = useState(false);
    const [drugs, setDrugs] = useState([]);

    useEffect(() => {
        if (props.data) {
            setLoading(true)
            getUserDetails(props.data.patientId).then(res => {
                setPatient(res.data);
                getPatientDrugAllegiesById(props.data.patientId).then(res => {
                    setLoading(false)
                    if (res.status && res.data) {
                        setDrugs(res.data)
                    }
                }).catch(err => {
                    setLoading(false)
                    console.log("err ==== ", err);
                })
            }).catch(err => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                console.log("err ==== ", err);
            })

        }
    }, [props.data.patientId]);

    return (
        loading ? <Loader /> :
            <div className="listContainer">
                <div className="hztlProfleRow">
                    <div className="hztlAvatar Md">
                        {patient.profileImage ?
                            <img src={patient.profileImage.url} alt="avatar" />
                            :
                            <img src="/images/icons/doctor-default.png" alt="avatar" />
                        }
                    </div>
                    <div className="hztlProfileInfo">
                        <span className="profleLTxt">{patient.firstName ? `${patient.firstName}` : ''}{patient.lastName ? ` ${patient.lastName}` : ''}</span>
                        <span className="profleSTxt capitalizeTxt">{patient.dob ? `${getAge(new Date(patient.dob))}` : ''} - {patient.gender ? patient.gender : ''}</span>
                        <span className="profleSTxt">{patient.dob ? `DOB - ${dateFormat(new Date(patient.dob))}` : ''}</span>
                    </div>
                </div>

                <div className="profileDtlsCol">
                    <div className="profleHdngRow">
                        <span className="profileSHdgn">{l.contact_details}</span>
                    </div>
                    <ul className="profileGroupCol">
                        {/* <li className="profileListItem">
                        <span className="profileInfoTxt">{l.h_no}</span>
                        <span className="profileInfoTxt dark">185/IDB/134H</span>
                        </li>*/}
                        <li className="profileListItem">
                            <span className="profileInfoTxt">{l.address}</span>
                            <span className="profileInfoTxt dark">{patient.address ? patient.address : ''}</span>
                        </li>
                        <li className="profileListItem">
                            <span className="profileInfoTxt">{l.pat_email}</span>
                            <span className="profileInfoTxt dark">{patient.email ? patient.email : ''}</span>
                        </li>
                        <li className="profileListItem">
                            <span className="profileInfoTxt">{l.pat_phone_no}</span>
                            <span className="profileInfoTxt dark">{patient.phone ? patient.phone : ''}</span>
                        </li>
                    </ul>


                    <div className="profleHdngRow">
                        <span className="profileSHdgn">{l.drug_All}</span>
                    </div>
                    <ul className="profileGroupCol">
                        {
                            drugs.map(drugItem =>
                                <>
                                    <li className="dotListItem">
                                        <span>Drug: {decodeURIComponent(drugItem.name)}</span>
                                        <span>Reaction: {decodeURIComponent(drugItem.description)}</span>
                                    </li>
                                </>
                            )
                        }
                    </ul>
                </div>
            </div>
    )
}

export default PatientMedicalProfile;